export const OS_LOT_REVIEW_DEFAULT_NGP_YEAR = 2026;

export type OsLotReviewClause = 'gp' | 'new';

export type OsLotReviewScopeSearch = {
  clause?: OsLotReviewClause;
  campaign_year?: number;
};

export type OsLotReviewScopeParams = {
  clause: OsLotReviewClause;
  campaign_year?: number;
};

export function osLotReviewScopeFromSearch(
  search: OsLotReviewScopeSearch,
): OsLotReviewScopeParams {
  if (search.clause === 'new') {
    return {
      clause: 'new',
      campaign_year: search.campaign_year ?? OS_LOT_REVIEW_DEFAULT_NGP_YEAR,
    };
  }
  return { clause: 'gp' };
}

export function osLotReviewScopeSearch(
  scope: OsLotReviewScopeParams,
): OsLotReviewScopeSearch {
  if (scope.clause === 'new') {
    return {
      clause: 'new',
      campaign_year: scope.campaign_year ?? OS_LOT_REVIEW_DEFAULT_NGP_YEAR,
    };
  }
  return { clause: 'gp' };
}
